import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Home';
import AboutUs from './AboutUs';
import Services from './Services';
import Pricing from './Pricing';
import OurWork from './OurWork';
import ContactUs from './ContactUs';
import { LanguageProvider } from './LanguageContext';
import ScrollToTop from './ScrollToTop';
import { WhatsAppFloat } from './SiteChrome';

function App() {
  return (
    <Router>
      <LanguageProvider>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/price" element={<Pricing />} />
            <Route path="/work" element={<OurWork />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
          <WhatsAppFloat />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
